<template>
  <LoadingDiv v-if="!isReady" />

  <div class="grey-bg-custom" v-else>
  <div class="container">
    <div class="row">
      <div class="col s12">
        <!-- <h1 class="teal-text">
          <i class="medium material-icons">filter_5</i> Providers
          <small>(Base-Tariff)</small>
        </h1> -->
      </div>
    </div>
    <div class="row" v-if="counter.length">
      <div class="col s12">
        <!-- Added -->
        <div class="card-panel" v-for="(count, id) in counter" :key="count.id">
          <div class="row">
            <div class="col s1">
              <span class="chip grey darken-2 white-text">{{ id + 1 }}</span>
            </div>
            <div class="col s9">
              <h5>
                {{ count.tariff }}
              </h5>
              <p>
                (<b>Total</b>) {{ count.value }} providers now using this
                <em>{{ count.value }}</em> tariff
                <i class="material-icons clickable brown-text" title="view all"
                  >visibility</i
                >
              </p>
            </div>
            <div class="col s2">
              <i class="material-icons teal-text">check_circle</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="section">
          <form @submit.prevent="handleSubmit">
            <div class="card-panel">
              <div class="file-field input-field">
                <div class="btn black">
                  <span>Provider (List)</span>
                  <input type="file" @change="handleFile" />
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path" v-model="inputFile" type="text" />
                  <p class="red-text" v-if="fileError">{{ fileError }}</p>
                </div>
              </div>
            </div>

            <div class="card-panel">
              <div class="input-field">
                <select v-model="plan">
                  <option value="" disabled selected>Select HMO Plan</option>
                  <option v-for="plan in plans" :key="plan.id" :value="plan">
                    {{ plan.name }}
                  </option>
                </select>
                <label>Type of Plan (Enrollees)</label>
              </div>
            </div>

            <p v-if="uploadError"><br />{{ uploadError }}</p>

            <p>
              <br />
              <button
                class="waves-effect waves-light btn-large"
                :class="{
                  disabled: !file || !plan || isSubmitting,
                }"
              >
                <i class="material-icons right">upload</i
                >{{ isSubmitting ? `Uploading (${uploadProgress})` : "Upload" }}
              </button>
            </p>
          </form>
        </div>
      </div>
    </div>
    <template v-if="!next">
      <div class="section right">
        <div class="row">
        <button class="waves-effect waves-light btn-large col s12 m3" @click="handleNext">
          <i class="material-icons left">call_made</i>Next
        </button>
        <!-- Spacer -->
        <span class="col m9"></span>
        </div>
        <p>
          <br />
          <br />
        </p>
      </div>
    </template>
  </div>
</div>
</template>
      
 <script>
import { onMounted, onUpdated, ref, computed, watchEffect } from "vue";
import getItems from "@/composables/getItems";
import useStorage from "@/composables/useStorage";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { adminAPI } from '@/laravel/config';
import M from "materialize-css";

export default {
  name: "ProviderSetupComponent",
  components: { LoadingDiv },
  emits: ["next"],
  setup(props, context) {
    const file = ref(null);
    const inputFile = ref(null);
    const fileError = ref(null);
    const response = ref(null);
    const error = ref(null);
    const isReady = ref(false);
    const isSubmitting = ref(false);
    const next = ref(false);
    const counter = ref([]);
    const plan = ref(null);
    const types = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

        // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
      })();
    };

    // storage
    const { uploadFile, uploadProgress, uploadError, data, completed } =
      useStorage();

      // starter
    onMounted(() => {
      // get plans
      getItemsFromApi("plan/private");
    });

    // drop down
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // drop down
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // clear
    const clearForm = () => {
      file.value = null; //clear file value
      inputFile.value = null; // Clear the file input value
      isSubmitting.value = false;
      uploadProgress.value = "0%";
    };

    // file
    const handleFile = (e) => {
      const selected = e.target.files[0];
      if (selected && types.includes(selected.type)) {
        file.value = selected;
        inputFile.value = file.value.name;
        fileError.value = null;
      } else {
        file.value = null;
        inputFile.value = null;
        fileError.value = "Please select an Excel file (.XLSX, XLS)";
      }
    };

    const handleSubmit = async () => {
      if (file.value && plan.value) {
        // Start Uploading
        isSubmitting.value = true;
        uploadError.value = null;

        // Cloud Function
        const fx = "providerLoader";

        // Round up
        const cloudInput = {
          plan_id: plan.value.id,
          endPoint: `https://api.welpro.easyhmo.com.ng/api/admin/provider/setup`,
        };

        console.log(adminAPI);

        // upload
        uploadFile(file.value, fx, cloudInput);
      } else {
        // clear all
        clearForm();
      }
    };

    // watch upload
    watchEffect(() => {
      if (completed.value) {
        //do stuff...
        // data.succ.Success, data.succ.inserted_rows, data.succ.Error
        // emit new parameters
        counter.value.push({
          tariff: plan.value.name,
          value: data.value.succ.inserted_rows,
        });

        // clear all
        clearForm();
      }
      if (uploadError.value) {
        // clear all
        clearForm();
      }
    });

    // handle submit
    const handleNext = () => {
      // next
      // emit new parameters
      context.emit("next", {
        step: 5,
        isComplete: true,
      });
    };

     // output results
    const plans = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    return {
      handleFile,
      handleNext,
      handleSubmit,
      next,
      counter,
      isReady,
      isSubmitting,
      plan,
      uploadProgress,
      fileError,
      uploadError,
      file,
      inputFile,
      plans,
    };
  },
};
</script>
      
<style>
.grey-bg-custom {
  background-color: #f2f2f2;
}
.hover-text {
  cursor: pointer;
}
.clickable {
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .grey-bg-custom .container {
    width: 94%;
  }

  .grey-bg-custom .row {
    margin-left: 0;
    margin-right: 0;
  }

  .grey-bg-custom .col {
    padding-left: 0;
    padding-right: 0;
    width: 100% !important;
  }

  .grey-bg-custom .card-panel {
    border-radius: 6px;
    box-shadow: none;
    padding: 16px;
  }

  .grey-bg-custom .btn,
  .grey-bg-custom .btn-large {
    width: 100%;
  }

  .grey-bg-custom .file-field .btn {
    margin-bottom: 10px;
  }
}
</style>
